var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.451 5.79877C12.3465 5.40605 12.0374 5.09623 11.6442 4.99005C10.9334 4.7995 8.08097 4.7995 8.08097 4.7995C8.08097 4.7995 5.23009 4.7995 4.51773 4.99005C4.126 5.09477 3.81697 5.40459 3.71106 5.79877C3.521 6.5115 3.521 7.99952 3.521 7.99952C3.521 7.99952 3.521 9.48752 3.71106 10.2003C3.81552 10.593 4.12455 10.9028 4.51773 11.009C5.23009 11.1995 8.08097 11.1995 8.08097 11.1995C8.08097 11.1995 10.9334 11.1995 11.6442 11.009C12.036 10.9043 12.345 10.5944 12.451 10.2003C12.641 9.48752 12.641 7.99952 12.641 7.99952C12.641 7.99952 12.641 6.5115 12.451 5.79877Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16943 9.37088L9.5387 7.99928L7.16943 6.62762V9.37088Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeCircle);
export default __webpack_public_path__ + "static/media/youtubeCircle.50f2be7adcd1355e826c59672cc97670.svg";
export { ForwardRef as ReactComponent };